import { toast } from "react-toastify";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { useEffect, useState } from "react";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import useModal, { MODAL_LG } from "../../../../theme/Component/hooks/useModal";
import { _FixedAssetItem } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import usePaginator from "../../../../theme/Component/usePaginator";
import { _BusinessProcess, _PlanMaintenanceArea, _RequestMaintenance, _single, _WorkMaintenanceOrder } from "../../../../../core/services/dataBean/EntityCatalog";
import { SelectLocationMaintenance } from "../../LocationMaintenance/SelectLocationMaintenance";
import { PlanMaintenanceItems } from "./PlanMaintenanceItems/PlanMaintenanceItems";
import { UpcomingMaintenance } from "../../UpcomingMaintenance/UpcomingMaintenance";
import { DropDown } from "../../../../theme/Component/DropDown";

interface Form {
    State: number;
}

interface Props {
    _planMaintenance: any;
}

export const PlanMaintenanceArea = ({ _planMaintenance }: Props) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_PlanMaintenanceArea);
    const paginador = usePaginator();

    const [form, setForm] = useState<Partial<Form>>({});

    const modalNew = useModal(`Mantenimientos Futuros`, MODAL_LG);
    const modalUpdate = useModal(`Maquinas Seleccionadad del area`, MODAL_LG);
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: 'Eliminar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [_planMaintenance])

    const getLista = () => {
        const props = {
            IDPlanMaintenance: _planMaintenance.IDPlanMaintenance,
            State: 1,
        }
        instance.getPlanMaintenanceAreaRender(paginador.page, 15, props).then(
            (resp: any) => {
                if (resp.List.length > 0) {
                    setLista(resp.List);
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * 15);
                    setBean({});
                } else {
                    setLista([])
                }
            }
        ).catch(err => { toast.error(err) });
    }

    const create = () => {
        setBean({
            State: 1,
            IDEmployee: _single.getAccountID(),
            IDPlanMaintenance: _planMaintenance.IDPlanMaintenance,
        });
        setModal({ ...modal, "name": `Agregar Plan de Mantenimientos de Area`, "view": true });
    }

    const deleteItem = () => {
        const x = { ...bean, State: 2 };
        editaItem(x);
        setModalC({ ...modalC, view: false });
    };

    const editaItem = (obj: any) => {
        instance.updatePlanMaintenanceArea(obj)
            .then((resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            })
            .catch(err => toast.error(err));
    };

    const head = [
        { title: 'ID', property: 'IDPlanMaintenanceArea', visible: true },
        { title: 'Area de Maquinas', property: 'MaintenanceAreaName', visible: true },
        { title: 'Cantidad de Maquinas', property: 'Quantity', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Fecha', property: 'Since', visible: true },
        { title: 'Empleado', property: 'AccountEntity', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: (_single.canCreate() && _planMaintenance.State === 1), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: (_single.canEdit() && _planMaintenance.State === 1), evento: () => { setModal({ ...modal, "name": `Editar ${bean.PlanName}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: (_single.canDelete() && _planMaintenance.State === 1), evento: () => { setModalC({ ...modalC, "view": true }) } },
            { titulo: 'Maquinas Seleccionadas', icono: 'ri-list-check-2', visible: true, evento: () => { modalUpdate.open(); } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const actionsDropDown = [
        { id: 1, name: 'Mantenimientos Pendientes/Futuros', permiso: null, activo: true },

    ];
    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    <DropDown lista={actionsDropDown} eventClick={(e) => {
                        if (e.id === 1) {
                            modalNew.open();
                        }
                    }}></DropDown>
                </div>
            </div>
        )
    }

    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable
                    headButtons={buttons()}
                    body={lista}
                    head={head}
                    rowSet={setBean}
                    listButtons={listaBotones()}
                    iconButtons={iconButtonsItem}
                    pageTop={paginador.page}
                    next={paginador.next}
                    back={paginador.back}
                    records={paginador}
                />

                <Modal modal={modal} updateModal={setModal} eventModal={() => { editaItem(bean) }}>
                    <div className="row">
                        <div className="col-md-6">
                            <SelectLocationMaintenance idSelector={bean.IDLocationMaintenance} onChange={(e) => { setBean({ ...bean, IDLocationMaintenance: e }) }} label="Area de Mantenimiento" />
                        </div>
                        <div className="col-md-6">
                            <label>Cantidad de Maquinas</label>
                            <input type="number" className="form-control" value={bean.Quantity} onChange={((e) => {
                                const value = e.target.value ? Number(e.target.value) : null;
                                setBean({ ...bean, Quantity: value })
                            })} />
                        </div>

                        <div className="col-md-12">
                            <label>Descripción</label>
                            <textarea className="form-control" value={bean.Description} onChange={(e) => { setBean({ ...bean, Description: e.target.value }) }}  ></textarea>
                        </div>
                    </div>
                </Modal>

                <Modal modal={modalNew.modal} updateModal={modalNew.setModal} >
                    <UpcomingMaintenance isModal />
                </Modal>

                <Modal modal={modalUpdate.modal} updateModal={modalUpdate.setModal} >
                    <div className="row">
                        <div className="col-12">
                            <PlanMaintenanceItems _planMaintenanceArea={bean} />
                        </div>
                    </div>
                </Modal>

                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar mantenimiento de {bean.FixedAssetDescription}</strong>
                </ModalConfirm>
            </div >

        </div >
    )
}